/*
 * @Author: your name
 * @Date: 2021-01-13 17:37:21
 * @LastEditTime: 2021-01-18 09:45:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue3-element-admin\src\router\globalRoutes.js
 */
export default [
    {
        path: "/login",
        name: "Login",
        component: () => import(/* @vite-ignore */ "@/views/Login.vue"),
    },
    {
        path: "/lighten_card",
        name: "lightenCard",
        component: () => import(/* @vite-ignore */ "@/views/layoutpages/lighten_card/index.vue"),
    },
    {
        path: "/404",
        name: "404",
        component: () => import(/* @vite-ignore */ "@/views/404.vue"),
    },
    {
        path: "/view_qrcode",
        name: "ViewQrcode",
        component: () => import(/* @vite-ignore */ "@/views/layoutpages/temp_image_text/ViewQrcode.vue"),
    },
    {
        path: "/show_image_text",
        name: "ShowImageText",
        component: () => import(/* @vite-ignore */ "@/views/layoutpages/temp_image_text/ShowImageText.vue"),
    },
    {
        path: "/tree_view",
        name: "TreeView",
        component: () => import(/* @vite-ignore */ "@/views/TreeView.vue"),
    },
];
